<div class="hint-container" *ngIf="value !== undefined">
  <div class="header">{{ translations.TEMPLATES.HINT | translate }}</div>
  <div class="text" [innerHTML]="formattedValue"></div>
</div>
